<script>
import qrcode from 'qrcode-generator'
export default {
  props: ['text'],
  methods: {
    drawQRCode (text) {
      if (!text) {
        return false
      }
      const qr = qrcode(0, 'M')
      qr.addData(text)
      qr.make()
      this.$refs.figure.innerHTML = qr.createImgTag(7, 24, 'QR Code')
    }
  },
  watch: {
    text (value) {
      this.drawQRCode(value)
    }
  },
  mounted () {
    this.drawQRCode(this.text)
  }
}
</script>

<template>
  <figure class="c-qrcode" ref="figure">
    <div v-if="!text">
      <div class="loader"></div>
    </div>
  </figure>
</template>

<style>
.c-qrcode {
  width: 100%;
  height: 100%;
}
.c-qrcode img {
  width: 100%;
  height: 100%;
}
.c-qrcode > div {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.c-qrcode .loader {
  width: 6rem;
  height: 6rem;
}
</style>



// WEBPACK FOOTER //
// src/components/design/c-qrcode.vue